import { render, staticRenderFns } from "./OctUploader.vue?vue&type=template&id=ea8dc182&"
import script from "./OctUploader.vue?vue&type=script&lang=js&"
export * from "./OctUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports